module.exports = __webpack_public_path__ + "static/media/left_distortion.c7e9474f.png";